import React, { useState, useRef, useEffect } from 'react';
import '../asset/css/CourseView.css';

const courseData = {
  id: 1,
  title: 'ႁဵၼ်းတႅမ်ႈၶူတ်ႉ Web development 1',
  subtitle: 'ႁဵၼ်းသွၼ်တႅမ်ႈၶူတ်ႉၶူင်သၢင်ႈဝႅပ်ႉသၢႆႉတႃႇၽူႈတီႈဢၼ်ဢမ်ႇပႆႇမေႃသင်တႄႇပိုၼ်ႉၶၢမ်ႇတေႃႇထိုင်ၸၼ်ႉ frontend',
  description: 'ပၢင်သွၼ်ၼႆႉ ပဵၼ်တႃႇၽူႈၸိူဝ်းၶႂ်ႈၶိုၼ်ႈၼႃႈ ၼႂ်းၵၢၼ်သၢင်ႈႁဵတ်းဢွၵ်ႇဝႅပ်ႉသၢႆႉ၊ တႄႇဢဝ်တီႈငဝ်ႈမၼ်း—ဢမ်ႇပႆႇမီးတၢင်းႁူႉတၢင်းႁၼ်သင်—လုၵ်ႈႁဵၼ်းၶဝ် တေလႆႈႁဵၼ်းႁူႉ လၢႆးႁဵတ်းၵၢၼ် ဝႅပ်ႉသၢႆႉ၊ တႄႇတႅမ်ႈ Code သေ လိုၼ်းသုတ်း တေမေႃႁဵတ်းဢွၵ်ႇ ဝႅပ်ႉသၢႆႉ ၽိုၼ်လိၵ်ႈသုၼ်ႇတူဝ် ဢၼ်တုမ်ႉတွပ်ႇလႆႈ ႁင်းၶဝ်ၼၼ်ႉယဝ်ႉ။',
  instructor: {
    name: 'Aon Mao',
    title: 'ၶူးသွၼ် ICT, ၽူႈၶူင်သၢင်ႈ Web, ၽူႈၶူင်သၢင်ႈ App',
    avatar: 'https://aonmao.me/static/media/mecircle.346f4873726923b60cf4.png',
    students: 64,
    courses: 2,
    rating: 4.9,
    bio: 'Aon Mao is ၼႆႉပဵၼ်ၽူႈၶူင်သၢင်ႈဝႅပ်ႉသၢႆႉလႄႈဢႅပ်ႉၵူႊသႅၼ်းသႅၼ်း တႄႉၶဝ်ႈၼႂ်းၵၢၼ်ပၢႆး IT မႃးၸႅမ်မိူဝ်ႈ 2020 ၼၼ်ႉသေ မိူဝ်ႈလဵဝ်မီးတူဝ်ထူပ်း 6 ပီႊယဝ်ႉ။ တႄႇပိုၼ်ႈၽႄ ပူင်သွၼ်ၽၢႆႇ IT ပၼ်လုၵ်ႈႁဵၼ်းလႄႈ ၵူၼ်းတင်းၼမ်မႃးၸဵမ်မိူဝ်ႈ 2022 လႄႈ မိူဝ်ႈလဵဝ်မီး 4 ပီႊယဝ်ႉ။ မိူဝ်ႈလဵဝ် ပိုတ်ႇပၢင်သွၼ်ၼိူဝ် online သေဢမ်ႇၵႃး တီႈႁိူၼ်း ၵေႃႈသွၼ်လႄႈ ႁပ်ႉပိုၼ်ႈၽႄတၢင်းႁူႉ IT ၵူႊတီႈတီႈယဝ်ႉ။',
  },
  category: 'ၶူတ်ႉ',
  level: 'ၽူႈတႄႇႁဵၼ်း',
  rating: 4.2,
  enrolledCount: 2,
  duration: '1 လိူၼ်',
  lessons: 30,
  lastUpdated: 'September 2026',
  language: 'Shan/ Burmese',
  mode: 'Online/ Offline',
  price: 70000,
  originalPrice: 100000,
  thumbnail: 'https://images.unsplash.com/photo-1558655146-9f40138eddb6?w=1200&h=675&fit=crop',
  htmlcontents: [
    'Website ပဵၼ်သင်?',
    'ဝႅပ်ႉသၢႆႉ (Website) ၼိူင်ႈဢၼ် မီးသင်ဝႆႉလၢႆႈလၢႆႈ?',
    'Front-end လႄႈ Back-end ပဵၼ်သင်?',
    'တွၼ်ႈသၢင်း(Install) App တႃႇတႅမ်ႈၶူတ်ႉ',
    'သၢင်ႈ Folder လႄႈ File တႃႇသိမ်း project files',
    'ႁၢင်ႊၽၢင်ၶူတ်ႉ html',
    'Text 1: Heading Tags (Tags ဢၼ်ၼေလိၵ်ႈႁူဝ်ၶေႃႈ)',
    'Text 2: Paragraph Tag (Tag ဢၼ်ၼေလိၵ်ႈၶေႃႈၵႂၢမ်း)',
    'Text 3: Bold Tag (Tag ဢၼ်ႁဵတ်းႁႂ်ႈတူဝ်လိၵ်ႈၼႃမႃး)',
    'Text 4: Italic Tag (Tag ဢၼ်ႁဵတ်းႁႂ်ႈတူဝ်လိၵ်ႈၶိတ်ႇ)',
    'Text 5: Underline Tag (သႂ်ႇၶိတ်ႉတႂ်ႈလိၵ်ႈ)',
    'Text 6: Strikethrough Tag (သႂ်ႇၶိတ်ႉၵၢင်လိၵ်ႈ)',
    'Text 7: Quoted Tag (သႂ်ႇၶွပ်ႇတူဝ်လိၵ်ႈ)',
    'Text 8: Span Tag',
    'Text 9: Label Tag (လိၵ်ႈဢၼ်ၸီႉၼေ)',
    'Button Tag (ၼေတူမ်ႇတဵၵ်း)',
    'Link Tag (ၼေလိင်ႉၵွင်ႉသၢၼ်)',
    'Image Tag (ၼေၶႅပ်းႁၢင်ႊ)',
    'Video Tag (ၼေဝီႇတီႇယူဝ်ႇ)',
    'Iframe Tag (ဢဝ်ဝႅပ်ႉသၢႆႉတၢင်းၼွၵ်ႇမႃးၼေ)',
    'Embed Tag (ဢဝ်ဝႅပ်ႉသၢႆႉတၢင်းၼွၵ်ႇမႃးၼေ)',
    'Input Tags (ၼေလွၵ်းတႅမ်ႈလိၵ်ႈ)',
    'List Tags (ၵၢၼ်ႁဵတ်းသဵၼ်ႈမၢႆ)',
    'Select Tag(တူမ်ႇဢၼ်လိူၵ်ႈလႆႈ)',
    'Table Tags(ၼေလွၵ်းယၢမ်း)',
    'Tag တၢင်ႇဢၼ် ဢၼ်ၸႂ်ႉၼမ်',
    'ႁူဝ်ႁုပ်ႈမၼ်း (Summary)'
  ],
  csscontents:[
    'CSS ပဵၼ်သင်? ၸႂ်ႉတိုဝ်းတီႈလႂ်? ႁဵတ်းႁိုဝ်ႁဵတ်းၵၢၼ်?',
    'လၢႆးၵွင်ႉၸႂ်ႉ CSS တင်း HTML',
    'ႁၢင်ႊၽၢင်ၶူတ်ႉ CSS',
    'ၵၢၼ်မႄးႁၢင်ႊလိၵ်ႈ (Text Styles in CSS)',
    'ၵၢၼ်သႂ်ႇသီပၼ်လိၵ်ႈ (Text Color)',
    'သီပိုၼ်ႉလင် (Background color in CSS)',
    'ၵၢၼ်ၸတ်းဝႆႉတီႈယူႇလိၵ်ႈ (Text Alignment)',
    'သႂ်သၢႆပၼ်လိၵ်ႈ (Text decoration)',
    'text-decoration-style (လၢႆႈႁၢင်ႊသဵၼ်ႈ)',
    'font-size (တၢင်းယႂ်ႇတူဝ်လိၵ်ႈ)',
    'ၵၢၼ်ပိၼ်ႇပဵၼ်လိၵ်ႈယႂ်ႇလိၵ်ႈလဵၵ်ႉ (Text Transformation)',
    'ပၼ်တၢင်းသုင်လႄႈတၢင်းၵႂၢင်ႈ (Width & Height)',
    'သႂ်ႇၶွပ်ႇ (Borders)',
    'ယၢၼ်တၢင်းၼႂ်း (Paddings)',
    'ယၢၼ်တၢင်းၼွၵ်ႈ (Margins)',
    'သႂ်ႇၶွပ်ႇၼွၵ်ႈ (Outlines)',
    'လွၵ်းလၢႆးပၼ်ၸိုဝ်ႈ',
    'ႁႂ်ႈၸဵင်ႇမူၼ်း (Border Radius)',
    'လၢႆးၸႂ်ႉ Flexbox',
    'လၢႆးၸႂ်ႉ CSS Grid',
    'ၸၼ် Simple Login Design',
    'ၸၼ် Simple Nav Bar Design',
    'ၸၼ် Simple Portfolio Design',
    'မႄးပဵၼ် Responsive Design'
  ],
  requirements: [
    'ဢမ်ႇမီးပိုၼ်ႉၶၢမ်ႇၶူတ်ႉၵေႃႈလႆႈ',
    'တေလႆႈမီးၶွမ်း ဢမ်ႇၼၼ် ၾူၼ်း',
  ],
  targetAudience: [
    'တႃႇၽူႈၶႂ်ႈပဵၼ်ၵူၼ်းတႅမ်ႈၶူတ်ႉ',
    'တႃႇၽူႈသူၼ်ၸႂ်ပၢႆးတႅမ်ႈၶူတ်ႉ',
    'တႃႇၸိူဝ်းတေၵႂႃႇၶိုၼ်ႈၸၼ်ႉၸွမ်ၶိူင်ႈၸၢၵ်ႈ IT',
    'တႃႇၽူႈၶႂ်ႈၸႂ်ႉပၢႆးၼႆႉသေႁႃၵၢၼ်',
  ],
  curriculum: [
    {
      id: 1,
      title: 'Video ၵၢၼ်သွၼ် Html',
      duration: '3h 31m 2s',
      lessons: 5,
      items: [
        { id: 1, title: 'ၵပ်းသိုပ်ႇပၢင်သွၼ်(Introduction)', type: 'video', duration: '3:45', free: false, completed: true },
        { id: 2, title: 'Lesson 1 - Website ပဵၼ်သင်?', type: 'video', duration: '17:03', free: false, completed: true },
        { id: 3, title: 'Lesson 2 - Front-end လႄႈ Back-end ပဵၼ်သင်?', type: 'video', duration: '16:58', free: false, completed: true },
        { id: 4, title: 'Lesson 3 - VS Code Installation သၢင်းဢႅပ်ႉတႃႇတႅမ်ႈၶူတ်ႉ', type: 'video', duration: '06:57', free: false, completed: true },
        { id: 5, title: 'Lesson 4 - Create File and Html Code Sample', type: 'video', duration: '21:25', free: false, completed: true },
        { id: 5, title: 'Lesson 5 - ၼႄလိၵ်ႈၼႂ်းဝႅပ်ႉသၢႆႉ', type: 'video', duration: '22:02', free: false, completed: true },
        { id: 5, title: 'Lesson 6 - Button & Link(ၼႄတူမ်ႇတဵၵ်းလႄႈလိင်ႉ)', type: 'video', duration: '19:24', free: false, completed: true },
        { id: 5, title: 'Lesson 7 - Image Tag(ၼႄၶႅပ်းႁၢင်ႊၼႂ်းဝႅပ်ႉသၢႆႉ)', type: 'video', duration: '14:28', free: false, completed: true },
        { id: 5, title: 'Lesson 8 - Video Tag(ၼႄဝီႇတီႇယူဝ်ႇၼႂ်းဝႅပ်ႉသၢႆႉ)', type: 'video', duration: '21:25', free: false, completed: true },
        { id: 5, title: 'Lesson 9 - Iframe & Embed Tags (လၢႆးဢဝ်ၼႃႈလိၵ်ႈပိူၼ်မႃးၼႄၼႂ်းဝႅပ်ႉသၢႆႉႁဝ်း)', type: 'video', duration: '10:13', free: false, completed: true },
        { id: 5, title: 'Lesson 10 - Input Tags (လွၵ်းတႅမ်ႈလိၵ်ႈ)', type: 'video', duration: '08:57', free: false, completed: true },
        { id: 5, title: 'Lesson 11 - List Tags (သၢင်ႈႁဵတ်းသဵၼ်ႈမၢႆၼႂ်းဝႅပ်ႉသၢႆႉ)', type: 'video', duration: '12:25', free: false, completed: true },
        { id: 5, title: 'Lesson 12 - Select Tag (တူမ်ႇဢၼ်လိူၵ်ႈလႆႈ)', type: 'video', duration: '04:14', free: false, completed: true },
        { id: 5, title: 'Lesson 13 - Table Tags (ၼႄလွၵ်းယၢမ်းၼႂ်းဝႅပ်ႉသၢႆႉ)', type: 'video', duration: '18:24', free: false, completed: true },
        { id: 5, title: 'Lesson 14 - Summary All Html Tags (ႁူပ်ႉၶိုၼ်းၵၢၼ်သွၼ် Html တင်းမူတ်း)', type: 'video', duration: '13:22', free: false, completed: true },
      ],
    },
    {
      id: 2,
      title: 'Video ၵၢၼ်သွၼ် CSS',
      duration: '4h 38m 23s',
      lessons: 7,
      items: [
        { id: 6, title: 'Lesson 15 - CSS ပဵၼ်သင်? ၸႂ်ႉတိုဝ်းတီႈလႂ်?', type: 'video', duration: '22:27', free: false, completed: true },
        { id: 7, title: 'Lesson 16 - ႁၢင်ႊၽၢင်ၶူတ်ႉ CSS လႄႈ လၢႆးပၼ်သီလိၵ်ႈ', type: 'video', duration: '16:39', free: false, completed: true },
        { id: 8, title: 'Lesson 17 - background,text-align,text-decoration,text-decoration-style,font size', type: 'video', duration: '19:37', free: false, completed: true },
        { id: 9, title: 'Lesson 18 - ၵၢၼ်ပိၼ်ႇလိၵ်ႈ(Text transform), ပၼ်တၢင်းသုင်လႄႈ တၢင်းၵႂၢင်ႈ(Width & Height)', type: 'video', duration: '15:13', free: false, completed: true },
        { id: 10, title: 'Lesson 19 - Borders, Padding, Margin, Outline', type: 'video', duration: '26:07', free: false, completed: true },
        { id: 11, title: 'Lesson 20 - လၢႆးပၼ်ၸိုဝ်ႈ (Class & ID)', type: 'video', duration: '06:50', free: false, completed: true },
        { id: 12, title: 'Lesson 21 - ႁႂ်ႈၸဵင်ႇမူၼ်း (Border Radius)', type: 'video', duration: '06:41', free: false, completed: true },
        { id: 12, title: 'Lesson 22 - လၢႆးၸႂ်ႉ Flex', type: 'video', duration: '28:34', free: false, completed: true },
        { id: 12, title: 'Lesson 23 - လၢႆးၸႂ်ႉ CSS Grid', type: 'video', duration: '14:25', free: false, completed: true },
        { id: 12, title: 'Lesson 24 - Simple Login Design(ၸၼ်ႁၢင်ႊၼႃႈၶဝ်ႈဢၵွင်ႉ)', type: 'video', duration: '30:58', free: false, completed: true },
        { id: 12, title: 'Lesson 25 - ၸၼ် Simple Nav Bar Design', type: 'video', duration: '19:15', free: false, completed: true },
        { id: 12, title: 'Lesson 26(A) - Simple Portfolio Design(ဝႅပ်ႉသၢႆႉၵပ်းသိုပ်ႇတူဝ်)', type: 'video', duration: '18:32', free: false, completed: true },
        { id: 12, title: 'Lesson 26(B) - Simple Portfolio Design(ဝႅပ်ႉသၢႆႉၵပ်းသိုပ်ႇတူဝ်)', type: 'video', duration: '10:43', free: false, completed: true },
        { id: 12, title: 'Lesson 26(C) - Simple Portfolio Design(ဝႅပ်ႉသၢႆႉၵပ်းသိုပ်ႇတူဝ်)', type: 'video', duration: '18:22', free: false, completed: true },
        { id: 12, title: 'Lesson 27 - Responsive Design(မႄးႁႂ်ႈဝႅပ်ႉသၢႆႉႁဝ်းၶဝ်ႈတူၺ်းလႆႈၵူႊၼႃႈ)', type: 'video', duration: '24:00', free: false, completed: true },
      ],
    },
  ],
  reviews: [
    {
      id: 1,
      user: 'Alexandar',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Alexandra',
      rating: 5,
      date: '1 week ago',
      text: 'ပၢင်သွၼ်ၼႆႉလီၶဝ်ႈၸႂ်တႄႉ။ ပပ်ႉႁဵၼ်းတႅမ်ႈၶူတ်ႉတႆး ဢၼ်ၸႂ်ႉၼႂ်းပၢင်သွၼ်ၵေႃႈ လႆႈယၢမ်ႈႁၼ်တီႈပၢင်သွၼ်ၼႆႉယဝ်ႉ။ ၶႅမ်ႉတႄႉ။ ပွင်ႇၸႂ်ငၢႆႈ။',
      helpful: 124,
      verified: true,
    },
  ],
};

const typeIcons = {
  video: 'ri-film-line',
  article: 'ri-file-text-line',
  assignment: 'ri-edit-line',
  resource: 'ri-folder-line',
  quiz: 'ri-question-line',
};

const typeLabels = {
  video: 'Video',
  article: 'Reading',
  assignment: 'Assignment',
  resource: 'Resources',
  quiz: 'Quiz',
};

function WebDev1Shn() {
  const [activeTab, setActiveTab] = useState('overview');
  const [expandedSection, setExpandedSection] = useState(1);
  const [currentLesson, setCurrentLesson] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const formatter = new Intl.NumberFormat('en-US');

  useEffect(() => {
    document.title = courseData.title;
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const formatDuration = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
  };

  const completedLessons = courseData.curriculum.reduce((acc, section) => {
    return acc + section.items.filter(item => item.completed).length;
  }, 0);

  const totalLessons = courseData.lessons;
  const progressPercent = Math.round((completedLessons / totalLessons) * 100);

  const handleLessonClick = (lesson, sectionId) => {
    if (lesson.type === 'video' || lesson.type === 'article') {
      setCurrentLesson({ ...lesson, sectionId });
    }
  };

  const handleEnroll = () => {
    alert('Enrollment flow would be triggered here');
  };

  const toggleSection = (sectionId) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  const shar=()=>{
    window.navigator.share({
      title: courseData.title,
      url:window.location.href
    })
  }
  return (
    <div className="course-view-page">
      <header className="course-header" style={{ backgroundImage: `url(${courseData.thumbnail})` }}>
        <div className="header-overlay">
          <div className="header-content">
            <div className="course-badge">
              <span className="badge category">{courseData.category}</span>
              <span className="badge level">{courseData.level}</span>
            </div>
            <h1 className="course-title">{courseData.title}</h1>
            <p className="course-subtitle">{courseData.subtitle}</p>
            <div className="course-meta-row">
              <div className="meta-item rating">
                <span className="rating-score">{courseData.rating}</span>
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className={`ri-star-fill ${i < Math.floor(courseData.rating) ? 'filled' : ''}`}></i>
                  ))}
                </div>
                <span className="review-count">({courseData.reviews.length.toLocaleString()} တၢင်းႁၼ်ထိုင်)</span>
              </div>
              <div className="meta-item students">
                <i className="ri-group-line"></i>
                <span>{courseData.enrolledCount.toLocaleString()} ၵေႃႉ</span>
              </div>
              <div className="meta-item duration">
                <i className="ri-time-line"></i>
                <span>{courseData.duration}</span>
              </div>
              <div className="meta-item lessons">
                <i class="ri-movie-line"></i>
                <span>{courseData.lessons} ဢၼ်</span>
              </div>
            </div>
            <div className="instructor-row">
              <img src={courseData.instructor.avatar} alt={courseData.instructor.name} className="instructor-avatar" />
              <div className="instructor-info">
                <span className="instructor-label">ၶူးသွၼ်</span>
                <div className="instructor-details">
                  <strong>{courseData.instructor.name}</strong>
                  <span>{courseData.instructor.title}</span>
                </div>
              </div>
              <div className="instructor-stats">
                <span><strong>{courseData.instructor.rating}</strong> ({courseData.instructor.students.toLocaleString()} ၵေႃႉ)</span>
                <span>ပၢင်သွၼ် {courseData.instructor.courses} ဢၼ်</span>
              </div>
            </div>
            <div className="header-actions">
              <a href='https://aonmao.me' target='_blank' className="btn btn-primary btn-lg" onClick={handleEnroll}>
                <i className="ri-shopping-cart-line"></i>
                <span>ၶဝ်ႈႁူမ်ႈ - {formatter.format(courseData.price)}Ks</span>
              </a>
              <button onClick={()=>{shar()}} className="btn btn-ghost btn-lg">
                <i className="ri-share-line"></i>
                <span>ပိုၼ်ႈၽႄ</span>
              </button>
            </div>
            <div className="guarantee">
              <i className="ri-shield-star-line"></i>
              <span>လႆႈတေႃႇၸူဝ်ႈ</span>
              <i className="ri-shield-star-line"></i>
              <span>လႆႈဝႂ် Certificate</span>
            </div>
          </div>
        </div>
      </header>

      <div className="course-body">
        <aside className="course-sidebar" ref={sidebarRef}>
          <div className="sidebar-card purchase-card">
            <div className="price-row">
              <div className="price-main">
                <span className="current-price">{formatter.format(courseData.price)}Ks</span>
                <span className="original-price">{formatter.format(courseData.originalPrice)}</span>
              </div>
              <span className="discount-badge">30% ယွမ်း</span>
            </div>
            <span style={{ margin: 0, alignSelf: 'end', fontSize: 12.9, color: '#333', marginBottom: 9 }}>တႃႇလုၵ်ႈႁဵၼ်းဢွၼ်တၢင်းသုတ်း 5 ၵေႃႉ</span>
            <a href='https://aonmao.me' target='_blank' className="btn btn-primary btn-block" onClick={handleEnroll}>
              <i className="ri-play-circle-line"></i>
              <span>ၶဝ်ႈႁူမ်ႈယၢမ်းလဵဝ်</span>
            </a>
            <div className="purchase-benefits">
              <div className="benefit"><i className="ri-check-line"></i> video 12 ဢၼ်</div>
              <div className="benefit"><i className="ri-check-line"></i> ၶဝ်ႈႁူမ်ႈလႆႈတေႃႇၸူဝ်ႈ</div>
              <div className="benefit"><i className="ri-check-line"></i> ၶဝ်ႈႁူမ်ႈလႆႈတင်း ၾူၼ်း လႄႈ ၶွမ်း</div>
              <div className="benefit"><i className="ri-check-line"></i> တေလႆႈဝႂ် Certificate</div>
            </div>
            <div onClick={()=>{shar()}} className="purchase-gift">
              <i className="ri-gift-line"></i>
              <span>Gift this course</span>
            </div>
          </div>

          <div className="sidebar-card info-card">
            <h3>လွင်ႈပၢင်သွၼ်</h3>
            <ul className="info-list">
              <li><span>တႄႇပၢင်သွၼ်</span><strong>{courseData.lastUpdated}</strong></li>
              <li><span>ၽႃႇသႃႇ</span><strong>{courseData.language}</strong></li>
              <li><span>မီးလၢႆး</span><strong>{courseData.mode}</strong></li>
              <li><span>တၢင်းႁိုင်</span><strong>{courseData.duration}</strong></li>
              <li><span>Video ၵၢၼ်သွၼ်</span><strong>{courseData.lessons} ဢၼ်</strong></li>
            </ul>
          </div>
        </aside>

        <main className="course-main">
          <div className="course-tabs" role="tablist">
            <button
              role="tab"
              aria-selected={activeTab === 'overview'}
              className={`course-tab ${activeTab === 'overview' ? 'active' : ''}`}
              onClick={() => setActiveTab('overview')}
            >
              {activeTab === 'overview' ?<i class="ri-file-list-3-fill"></i>:<i className="ri-file-list-3-line"></i>}
              <span>ႁူပ်ႈတူၺ်း</span>
            </button>
            <button
              role="tab"
              aria-selected={activeTab === 'coursecontents'}
              className={`course-tab ${activeTab === 'coursecontents' ? 'active' : ''}`}
              onClick={() => setActiveTab('coursecontents')}
            >
              {activeTab === 'coursecontents' ?<i class="ri-article-fill"></i>:<i class="ri-article-line"></i>}
              <span>ႁူဝ်ၶေႃႈၵၢၼ်သွၼ်</span>
            </button>
            <button
              role="tab"
              aria-selected={activeTab === 'vidcontent'}
              className={`course-tab ${activeTab === 'vidcontent' ? 'active' : ''}`}
              onClick={() => setActiveTab('vidcontent')}
            >
              {activeTab === 'vidcontent' ?<i class="ri-video-fill"></i>:<i class="ri-video-line"></i>}
              <span>Video ၵၢၼ်သွၼ်</span>
              <span className="tab-count">{courseData.lessons} ဢၼ်</span>
            </button>
            <button
              role="tab"
              aria-selected={activeTab === 'reviews'}
              className={`course-tab ${activeTab === 'reviews' ? 'active' : ''}`}
              onClick={() => setActiveTab('reviews')}
            >
              {activeTab === 'reviews' ?<i class="ri-star-fill"></i>:<i className="ri-star-line"></i>}
              <span>တၢင်းႁၼ်ထိုင်</span>
              <span className="tab-count">{courseData.reviews.length.toLocaleString()}</span>
            </button>
            <button
              role="tab"
              aria-selected={activeTab === 'instructor'}
              className={`course-tab ${activeTab === 'instructor' ? 'active' : ''}`}
              onClick={() => setActiveTab('instructor')}
            >
              {activeTab === 'instructor' ?<i class="ri-user-fill"></i>:<i className="ri-user-line"></i>}
              <span>ၶူးသွၼ်</span>
            </button>
          </div>

          {activeTab === 'vidcontent' && (
            <div className="tab-panel" role="tabpanel">
              <div className="curriculum-header">
                <h2>Video ၵၢၼ်သွၼ်</h2>
                <div className="curriculum-summary">
                  <span>{courseData.curriculum.length} တွၼ်ႈ</span>
                  <span>•</span>
                  <span>{courseData.lessons} ဢၼ်</span>
                  <span>•</span>
                  <span>8h 9m 25s တၢင်းၼမ်</span>
                </div>
                <button className="btn-expand" onClick={() => setExpandedSection(expandedSection ? null : 1)}>
                  <i className={expandedSection ? 'ri-collapse-line' : 'ri-expand-line'}></i>
                  {expandedSection ? 'ပိၵ်ႉတင်းမူတ်း' : 'ၼႄတင်းမူတ်း'}
                </button>
              </div>

              <div className="curriculum-list">
                {courseData.curriculum.map((section) => (
                  <section key={section.id} className="curriculum-section">
                    <div className="section-header" onClick={() => toggleSection(section.id)}>
                      <div className="section-toggle">
                        <i className={`ri-arrow-down-s-line ${expandedSection === section.id ? 'expanded' : ''}`}></i>
                      </div>
                      <div className="section-info">
                        <h3>{section.title}</h3>
                        <div className="section-meta">
                          <span>{section.items.length} ဢၼ်</span>
                          <span>•</span>
                          <span>{section.duration}</span>
                        </div>
                      </div>
                      <div className="section-progress">
                        <div className="progress-bar-mini" style={{ width: '120px' }}>
                          <div className="progress-fill" style={{ width: '51%' }}></div>
                        </div>
                        <span className="progress-text">50%</span>
                      </div>
                    </div>

                    {expandedSection === section.id && (
                      <ul className="section-lessons">
                        {section.items.map((lesson) => (
                          <li key={lesson.id} className="lesson-row">
                            <div className="lesson-drag">
                              <i className="ri-drag-move-line"></i>
                            </div>
                            <div className="lesson-type-icon">
                              <i className={typeIcons[lesson.type]}></i>
                            </div>
                            <div className="lesson-info">
                              <div className="lesson-title-row">
                                <span className="lesson-title">{lesson.title}</span>
                                {lesson.free && <span className="free-badge">Free</span>}
                              </div>
                              <div className="lesson-meta">
                                <span className="lesson-type">{typeLabels[lesson.type]}</span>
                                <span>•</span>
                                <span className="lesson-duration">{lesson.duration}</span>
                              </div>
                            </div>
                            <div className="lesson-status">
                              {lesson.completed ? (
                                <i className="ri-check-circle-fill completed"></i>
                              ) : (
                                <button className="btn-lesson" onClick={() => handleLessonClick(lesson, section.id)}>
                                  {lesson.type === 'video' ? 'Preview' : 'Start'}
                                </button>
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </section>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'overview' && (
            <div className="tab-panel" role="tabpanel">
              <div className="overview-grid">
                <div className="overview-section full-width">
                  <h2>ၶေႃႈၵႂၢမ်း</h2>
                  <div className="description-text">
                    <p>{courseData.description}</p>
                  </div>
                </div>

                <div className="overview-section">
                  <h2>လွင်ႈလူဝ်ႇ</h2>
                  <ul className="check-list">
                    {courseData.requirements.map((item, i) => (
                      <li key={i}><i className="ri-check-line"></i> {item}</li>
                    ))}
                  </ul>
                </div>

                <div className="overview-section">
                  <h2>ပၢင်သွၼ်ၼႆႉပဵၼ်တႃႇ</h2>
                  <ul className="check-list">
                    {courseData.targetAudience.map((item, i) => (
                      <li key={i}><i className="ri-check-line"></i> {item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div className="tab-panel" role="tabpanel">
              {/*<div className="reviews-header">
                <div className="rating-summary">
                  <div className="overall-rating">
                    <span className="big-rating">{courseData.rating}</span>
                    <div className="stars-large">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill ${i < Math.floor(courseData.rating) ? 'filled' : ''}`}></i>
                      ))}
                    </div>
                    <span className="total-reviews">{courseData.reviewCount.toLocaleString()} reviews</span>
                  </div>
                  <div className="rating-bars">
                    {[5, 4, 3, 2, 1].map((star) => (
                      <div key={star} className="rating-bar-row">
                        <span>{star} star</span>
                        <div className="rating-bar">
                          <div className="rating-bar-fill" style={{ width: `${star === 5 ? 65 : star === 4 ? 20 : star === 3 ? 10 : star === 2 ? 3 : 2}%` }}></div>
                        </div>
                        <span>{star === 5 ? '1850' : star === 4 ? '567' : star === 3 ? '284' : star === 2 ? '89' : '57'}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <button className="btn btn-primary" onClick={() => setShowReviewModal(true)}>
                  <i className="ri-edit-line"></i>
                  <span>Write a Review</span>
                </button>
              </div>*/}

              <div className="reviews-list">
                {courseData.reviews.map((review) => (
                  <article key={review.id} className="review-card">
                    <div className="review-header">
                      <img src={review.avatar} alt={review.user} className="review-avatar" />
                      <div className="review-user">
                        <div className="user-name-row">
                          <strong>{review.user}</strong>
                          {review.verified && <i className="ri-checkbox-circle-fill verified" title="Verified Purchase"></i>}
                        </div>
                        <div className="review-meta">
                          <div className="review-stars">
                            {[...Array(5)].map((_, i) => (
                              <i key={i} className={`ri-star-fill ${i < review.rating ? 'filled' : ''}`}></i>
                            ))}
                          </div>
                          <span className="review-date">{review.date}</span>
                        </div>
                      </div>
                    </div>
                    <p className="review-text">{review.text}</p>
                  </article>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'coursecontents' && (
            <div className="tab-panel" role="tabpanel">
              <div className="overview-grid">
                <div className="overview-section">
                  <h2>ႁူဝ်ၶေႃႈၼႂ်းၵၢၼ်ႁဵၼ်း Html</h2>
                  <ol className="check-list">
                    {courseData.htmlcontents.map((item, i) => (
                      <li key={i}><i className="ri-check-line"></i> {item}</li>
                    ))}
                  </ol>
                </div>
                <div className="overview-section">
                  <h2>ႁူဝ်ၶေႃႈၼႂ်းၵၢၼ်ႁဵၼ်း CSS</h2>
                  <ol className="check-list">
                    {courseData.csscontents.map((item, i) => (
                      <li key={i}><i className="ri-check-line"></i> {item}</li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'instructor' && (
            <div className="tab-panel" role="tabpanel">
              <div className="instructor-profile">
                <div className="instructor-header">
                  <img src={courseData.instructor.avatar} alt={courseData.instructor.name} className="instructor-avatar-large" />
                  <div className="instructor-info-full">
                    <h2>{courseData.instructor.name}</h2>
                    <p className="instructor-title">{courseData.instructor.title}</p>
                    <div className="instructor-rating">
                      <span className="rating-score">{courseData.instructor.rating}</span>
                      <div className="stars">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < Math.floor(courseData.instructor.rating) ? 'filled' : ''}`}></i>
                        ))}
                      </div>
                      <span>(လုၵ်ႈႁဵၼ်း {courseData.instructor.students.toLocaleString()} ၵေႃႉ, {courseData.instructor.courses} ပၢင်သွၼ်)</span>
                    </div>
                  </div>
                </div>
                <div className="instructor-bio">
                  <h3>လွင်ႈၶူးသွၼ်</h3>
                  <p>{courseData.instructor.bio}</p>
                </div>
                <div className="instructor-stats-full">
                  <div className="stat-box">
                    <span className="stat-number">{courseData.instructor.students.toLocaleString()}</span>
                    <span className="stat-label">လုၵ်ႈႁဵၼ်းတင်းမူတ်း</span>
                  </div>
                  <div className="stat-box">
                    <span className="stat-number">{courseData.instructor.courses}</span>
                    <span className="stat-label">ပၢင်သွၼ်တင်းမူတ်း</span>
                  </div>
                  <div className="stat-box">
                    <span className="stat-number">{courseData.instructor.rating}</span>
                    <span className="stat-label">တၢင်းႁၼ်ထိုင်</span>
                  </div>
                  <div className="stat-box">
                    <span className="stat-number">6+</span>
                    <span className="stat-label">တူဝ်ထူပ်း(ပီႊ)</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>

      {currentLesson && (
        <div className="lesson-player-overlay" onClick={() => setCurrentLesson(null)}>
          <div className="lesson-player" onClick={(e) => e.stopPropagation()}>
            <button className="player-close" onClick={() => setCurrentLesson(null)}>
              <i className="ri-close-line"></i>
            </button>
            <div className="player-header">
              <h3>{currentLesson.title}</h3>
              <span className="player-type">{typeLabels[currentLesson.type]}</span>
            </div>
            <div className="player-content">
              {currentLesson.type === 'video' && (
                <div className="video-placeholder">
                  <i className="ri-play-circle-line"></i>
                  <span>Video Player - {currentLesson.duration}</span>
                </div>
              )}
              {currentLesson.type === 'article' && (
                <div className="article-placeholder">
                  <i className="ri-file-text-line"></i>
                  <span>Reading Material - {currentLesson.duration}</span>
                </div>
              )}
              {currentLesson.type === 'assignment' && (
                <div className="assignment-placeholder">
                  <i className="ri-edit-line"></i>
                  <span>Assignment - {currentLesson.duration}</span>
                </div>
              )}
              {currentLesson.type === 'resource' && (
                <div className="resource-placeholder">
                  <i className="ri-folder-line"></i>
                  <span>Downloadable Resources - {currentLesson.duration}</span>
                </div>
              )}
            </div>
            <div className="player-footer">
              <button className="btn btn-primary">Mark as Complete</button>
              <button className="btn btn-secondary">Next Lesson</button>
            </div>
          </div>
        </div>
      )}

      {showReviewModal && (
        <div className="review-modal-overlay" onClick={() => setShowReviewModal(false)}>
          <div className="review-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Write a Review</h3>
              <button className="modal-close" onClick={() => setShowReviewModal(false)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
            <form className="review-form">
              <div className="form-group">
                <label>Your Rating</label>
                <div className="star-rating-input">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className={`ri-star-line`}></i>
                  ))}
                </div>
              </div>
              <div className="form-group">
                <label>Your Review</label>
                <textarea placeholder="Share your experience with this course..." rows={5}></textarea>
              </div>
              <div className="form-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowReviewModal(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary">Submit Review</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default WebDev1Shn;